/**
 * @fileoverview GET handler for the "/engagement/api/segment_cohorts/:id/engagements" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { engagementApiSegmentCohortsIdEngagements } from "./constants";
import type { EngagementsResponse } from "./types";

export const getSegmentCohortEngagements = reactQueryFetcherAdapter(
  engagementApiSegmentCohortsIdEngagements,
  (signal: AbortSignal, segmentCohortId: string, includeInactive: boolean): Promise<EngagementsResponse> => {
    return fetch(
      `/engagement/api/segment_cohorts/${segmentCohortId}/engagements`,
      "GET",
      { include_inactive: includeInactive },
      { signal }
    );
  }
);
